export function getServerOptions(scene7Domain, config, scene7ServerMandatory, damEnv) {
    const scene7Config = config.scene7Config;
    if (config.author) {
        const liveDamEnvs = scene7Config.liveDamEnvs || [];
        if (damEnv && liveDamEnvs.includes(damEnv)) {
            return {
                lockingEnabled: Boolean(scene7Config.liveLockingEnabled),
                obfuscationEnabled: Boolean(scene7Config.liveObfuscationEnabled),
                domain: scene7Config.liveDomain
            };
        }
        if (scene7Config.usePreviewDomain) {
            return {
                lockingEnabled: Boolean(scene7Config.previewLockingEnabled),
                obfuscationEnabled: Boolean(scene7Config.previewObfuscationEnabled),
                domain: scene7Config.previewDomain
            };
        }
        if (!scene7ServerMandatory) {
            return {
                lockingEnabled: Boolean(scene7Config.previewLockingEnabled),
                obfuscationEnabled: Boolean(scene7Config.previewObfuscationEnabled),
                domain: ''
            };
        }
    }
    const domain = !scene7Config.forceLiveDomain && scene7Domain
        ? scene7Domain
        : scene7Config.liveDomain;
    return {
        lockingEnabled: Boolean(scene7Config.liveLockingEnabled),
        obfuscationEnabled: Boolean(scene7Config.liveObfuscationEnabled),
        domain
    };
}
